export class ContractRevertRequest {

    contractId: number;
    vin: string;
    productId: number;
}